var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "kwt-basic-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-head",
    on: {
      "click": _vm.handleClickOnHead
    }
  }, [_c('span', [_vm._v(_vm._s(this.selectedItem || 'Choose an item.'))]), _c('figure', {
    staticClass: "arrow-down"
  })]), _vm.open ? _c('ul', _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.handleSelectItem(item);
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]);
  }), 0) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }